import { render, staticRenderFns } from "./AccountTypeBanner.vue?vue&type=template&id=6012e1d4"
import script from "./AccountTypeBanner.vue?vue&type=script&lang=js"
export * from "./AccountTypeBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports